import React, { Component } from 'react';
import PrivacyPolicy from '../components/pages/GDPR/PrivacyPolicy';
import { connect } from 'react-redux';
import { buttonEventHandler, notifyEmailUpdate } from '../actions/profileActions';
import { AppDispatch, RootState } from '../store';

class PrivacyPolicyGDPR extends Component {
  render() {
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    return <PrivacyPolicy {...this.props} />;
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    gdpr_acknowledged: state.auth.gdpr_acknowledged,
    gdpr_Step2: state.auth.gdpr_Step2,
    isAuthenticated: state.auth.isAuthenticated,
    profile: state.profile,
    username: state.profile.username,
    isFetching: state.common.isFetching,
    notification: state.notification,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch, ownProps: RootState) => {
  return {
    buttonEventHandler(isAccept) {
      dispatch(buttonEventHandler(isAccept, ownProps.navigate));
    },
    notifyEmailUpdate: (notifyEmail, callback) => {
      dispatch(notifyEmailUpdate(notifyEmail, ownProps.navigate)).then(() => {
        if (typeof callback === 'function') {
          callback();
        }
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicyGDPR);
